<template>
  <header class="relative clear-left mb-5">
    <h1 class="flex items-center flex-wrap text-24 sm:text-28 font-bold text-white tracking-tight leading-snug">
      <div
        ref="horoscopeSelectPopperTrigger"
        class="mr-2"
        @mouseenter="horoscopeSelectPopper.show()"
        @mouseleave="horoscopeSelectPopper.hide()"
      >
        <div class="flex items-center">
          <span class="mr-1">{{ horoscopeName }} Burcu</span>
          <OIcon icon="right-white" class="rotate-90" />
        </div>
        <OPopper
          ref="horoscopeSelectPopperView"
          :is-visible="horoscopeSelectPopper.visible"
          class="
            bg-black
            border border-[#424242]
            !w-[306px]
            sm:!w-[586px]
            mx-4
            sm:mx-0
            gap-3
            p-3
            sm:p-6
            rounded-xl
            z-2
            shadow
            right-auto
            flex flex-wrap
            items-center
          "
        >
          <OLink
            v-for="item in horoscopes"
            :key="item.name"
            class="
              w-[84px]
              sm:w-[125px]
              px-2
              sm:px-8
              py-2
              sm:py-4
              bg-[#181819]
              u-center
              text-md
              sm:text-lg
              font-medium
              text-white
              hover:bg-[#6842EF] hover:text-white
              whitespace-nowrap
              rounded-full
            "
            :class="{ 'bg-[#6842EF]': item.name === horoscopeName }"
            :href="getHoroscopeUrl(item['slug-en'])"
          >
            {{ item.name }}
          </OLink>
        </OPopper>
      </div>
      {{ dateText }},
      {{ title }}
    </h1>
  </header>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { OLink, OPopper, OIcon } from '~/modules/common/components/ui';
import { usePopper } from '~/composables/usePopper';
import horoscopes from '~/static/json/horoscopes.json';
import {
  getHoroscopeName,
  getDateText,
  getFrequencyText,
  getHoroscopeTypeText,
  createHoroscopeUrl,
} from '~/modules/astrology/utils/astrologyUtils';
export default defineComponent({
  props: {
    horoscope: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    frequency: {
      type: String,
      required: true,
    },
  },
  components: {
    OLink,
    OPopper,
    OIcon,
  },
  setup(props) {
    const [horoscopeSelectPopperTrigger, horoscopeSelectPopperView, horoscopeSelectPopper] = usePopper({
      placement: 'bottom-start',
      modifiers: [
        {
          name: 'computeStyles',
          options: {
            adaptive: false, // true by default
          },
        },
      ],
    });
    const horoscopeName = ref(getHoroscopeName(props.horoscope));
    const dateText = ref(getDateText(props.date));
    const frequencyText = getFrequencyText(props.frequency);
    const typeText = getHoroscopeTypeText(props.type);
    const title = ref(frequencyText + ' ' + typeText + ' Burç Yorumu');

    const getHoroscopeUrl = (horoscope) => {
      return createHoroscopeUrl({ horoscope, date: props.date, frequency: props.frequency, type: props.type });
    };

    return {
      horoscopeSelectPopperTrigger,
      horoscopeSelectPopperView,
      horoscopeSelectPopper,
      dateText,
      title,
      horoscopes,
      horoscopeName,
      getHoroscopeUrl,
    };
  },
});
</script>
